module.exports = __webpack_public_path__ + "img/afg.008dc322.svg";